<div class="canvas-container">
  <canvas baseChart [datasets]="datasets"  [labels]="doughnutChartLabels" [chartType]="chartType"
    [colors]="chartColors" [options]="options" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)" width="auto" height="216">
  </canvas>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/components/doughnut-chart/doughnut-chart.component.html